import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';

@Injectable({
    providedIn: 'root'
})
export class AndarDBService extends DatabaseService {
    override classname: string = 'AndarDBService';
    override table = 'andar';

    protected override migration: number = 1;

    override indices = [
        { name: "by_id", field: "id", unique: false, multiEntry: false },
        { name: "by_edificacao", field: "edificacao_id", unique: false, multiEntry: false },
        { name: "by_sinc", field: "sinc", unique: false, multiEntry: false }
    ];
}
